export default __webpack_public_path__ + "static/media/processionial (2).cec1f3c8.jpg";